import React from "react";

export default function Footer() {
  return (
    <footer>
      <p>
        Made with love ❤️ for eternal knowledge seekers.
      </p>
      <p>
        Visit: <a href="https://mindslog.com" target="_blank" rel="noopener noreferrer">mindslog.com</a>
      </p>
      <p className="copyright">© 2024 Minds Log. All rights reserved.</p>
    </footer>
  );
}
